"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.RawHtml = void 0;

var _react = require("react");

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/**
 * `RawHtml` component.
 */
var RawHtml = function RawHtml(props) {
  var children = props.children,
      element = props.element,
      rest = _objectWithoutProperties(props, ["children", "element"]);

  return (0, _react.createElement)(element, _objectSpread({}, rest, {
    dangerouslySetInnerHTML: {
      __html: children // eslint-disable-line id-match

    }
  }));
};
/**
 * Default props.
 */


exports.RawHtml = RawHtml;
RawHtml.defaultProps = {
  element: 'span'
};
/**
 * Export `RawHtml` component.
 */

var _default = RawHtml;
exports.default = _default;